module.exports = __webpack_public_path__ + "img/sheep.cbbc5a25.png";